import { getLocale, getProfileId } from 'lib/store';
import { isValidJSON } from 'lib/utils';
import { apiClient } from 'services/api-client';
import { VoiceUploadPayload } from './type';

export const getVoiceScanReports = async (args?: {
  page_number: number;
  page_size: number;
}) => {
  return (await apiClient.get('voice-report', {
    params: {
      locale: getLocale(),
      profile_id: getProfileId(),
      os: 'web',
      page_number: args?.page_number || 1,
      page_size: args?.page_size || 10,
    },
  })) as string;
};

export const getVoiceScanDetails = async (sessoin_id: string) => {
  const response = (await apiClient.get('/voice-report', {
    params: {
      locale: getLocale(),
      profile_id: getProfileId(),
      sessoin_id,
      os: 'web',
    },
  })) as string;
  if (response && isValidJSON(response)) {
    return JSON.parse(response);
  }

  return response;
};

export const deleteVoiceScan = async ({
  session_id,
}: {
  session_id: string[];
}) => {
  return (await apiClient.delete('/voice-report', {
    data: { session_id },
    params: {
      locale: getLocale(),
      profile_id: getProfileId(),
      os: 'web',
    },
  })) as { success: boolean };
};

export const getVoiceScanImage = async () => {
  return (await apiClient.post(
    '/voice-process',
    {},
    {
      params: {
        profile_id: getProfileId(),
        action: 'get_image',
      },
    }
  )) as { image_id: string; image_url: string };
};

export const initiateVoiceScanSession = async ({
  imageId,
}: {
  imageId: string;
}) => {
  return (await apiClient.post(
    '/voice-process',
    { image_id: imageId },
    {
      params: {
        profile_id: getProfileId(),
        action: 'initiate',
      },
    }
  )) as { session_id: string };
};

export const uploadVoiceRecording = async (payload: VoiceUploadPayload) => {
  const arrayBuffer = await payload.audioBlob.arrayBuffer();
  const audioData = new Uint8Array(arrayBuffer);

  return await apiClient.post('/voice-process', audioData, {
    params: {
      profile_id: getProfileId(),
      action: 'upload_recording',
      session_id: payload?.sessionId,
      format: 'wav',
      duration: payload?.duration.toString(),
    },
    headers: {
      'Content-Type': 'audio/wav',
    },
  });
};

export async function processVoiceRecording({
  sessionId,
}: {
  sessionId: string;
}) {
  return await apiClient.post(
    '/voice-process',
    { session_id: sessionId },
    {
      params: {
        profile_id: getProfileId(),
        action: 'process_recording',
      },
    }
  );
}

export async function getVoiceScanReportDetail({
  sessionId,
}: {
  sessionId: string;
}) {
  const response = (await apiClient.get('/voice-report', {
    params: {
      locale: getLocale(),
      profile_id: getProfileId(),
      sessoin_id: sessionId,
      os: 'web',
    },
  })) as string;

  if (response && isValidJSON(response)) {
    return JSON.parse(response);
  }

  return response;
}
